import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../../../components-core/packages/components-core/dist/layout/index';
import { AspectRatioContainer, AspectRatio } from '../../../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../../../components-core/packages/components-core/dist/image/index';
import { FixedWidthContainer } from '../../../../../components-core/packages/components-core/dist/fixed-width-container/index';
import { BreakpointWrapper } from '../../../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { Accordion } from '../../../../../components-core/packages/components-core/dist/accordion/index';
import { Link } from '../../../../../components-core/packages/components-core/dist/link/index';
import PriceListOptionalAccrodion from '../../../price-list-optional-accordion/PriceListOptionalAccrodion'
import PriceAccordion from '../../../price-accordion/PriceAccordion'
//CUSTOM COMPONENTS
import TableHeader from '../table-header/TableHeader';
import AccordionContentRows from '../accordion-content-row/AccordionContentRow';
import trendlineImage from '../../inner-components/price-table/caddy-trendline.png'
import exclusiveImage from '../../inner-components/price-table/caddy-exclusive.png'
import maxiVanImage from '../../inner-components/price-table/caddy-maxivan.png'
import comfortlineImage from '../../inner-components/price-table/caddy-comfortline.png'
import trCityVan from '../../inner-components/price-table/tr-cityvan.png'
import trPanelVan from '../../inner-components/price-table/tr-panelvan.png'
import trPikap from '../../inner-components/price-table/tr-pikap.png'
import careComfortline from '../../inner-components/price-table/cara-comfortline.png'
import careHighline from '../../inner-components/price-table/care-highline.png'
import amarokHighline from '../../inner-components/price-table/amarok-highline.png'
import amarokAventura from '../../inner-components/price-table/amarok-aventura.png'
import amarokCanyon from '../../inner-components/price-table/amarok-canyon.png'
import crafterOkul from '../../inner-components/price-table/crafter-okul.png'
import crafterServis from '../../inner-components/price-table/crafter-servis.png'
import crafterPanelVan from '../../inner-components/price-table/crafter-panelvan.png'


const TableContainer = styled.div`
    border: 1px solid;
    border-color: #dfe4e8;
    width: 100%;
`;

const BoldLine = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
`;

const Row = styled.tr`
    border: none;
    width: 100%;
`;

const ColorContainer = styled.div`
    background-color: red;
`;

/**
 * TODO @TugkanPilka: Kullanıcılar iki farklı accordionu aynı anda açmak isteyebilir.
 * renderAccordion() metodunu gözden geçir.
 */
class PriceTable extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: null
        }
    }

    renderAccordion() {
        const { selectedIndex } = this.state;

        if (!this.props.priceList) {
            return;
        }
        if (this.props.selectedIndex === 0) {

        }

        const renderedAccordion = this.props.priceList.map((data, index) =>
            <Accordion
                id={index.toString()}
                headline={accordionHeadline(data.countrymodel_definition, data.ListPrice)}
                isOpen={selectedIndex === index}
                onClick={() => this.setState({ selectedIndex: index === selectedIndex ? null : index })}
            >
                <Container stretchContent={true} padding={{ bottom: ContainerPadding.static200 }} >
                    <BoldLine />
                </Container>
            </Accordion>
        )

        return (
            <Container
                stretchContent={true}
                padding={accordionContainerPadding}
                gutter={ContainerGutter.dynamic0100}
                wrap={ContainerWrap.always}
            >
                {renderedAccordion}
            </Container>
        )
    }

    render() {
        return (
            <ThemeProvider>
                <Container stretchContent={true} padding={topContainerPadding}>
                    <TableHeader name={this.props.carName} />
                    <TableContainer>
                        <Container
                            stretchContent={true}
                            padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0200 }}
                        >
                            <Layout appearance={layoutConfigurations}>
                                {showCarImage(this.props.carImage)}
                                {initAccordions(this.props.carName, this.props)}
                            </Layout>

                        </Container>
                    </TableContainer>
                </Container>
            </ThemeProvider>
        )
    }
}

const showCarImage = (carImage) => {
    if (carImage === 1) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={trendlineImage} />
            </Container>
        )
    }
    else if (carImage === 2) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={comfortlineImage} />
            </Container>
        )
    }
    else if (carImage === 3) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={exclusiveImage} />
            </Container>
        )
    }
    else if (carImage === 4) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={maxiVanImage} />
            </Container>
        )
    }
    else if (carImage === 5) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={trCityVan} />
            </Container>
        )
    }
    else if (carImage === 6) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={trPanelVan} />
            </Container>
        )
    }
    else if (carImage === 7) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={trPikap} />
            </Container>
        )
    }
    else if (carImage === 8) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={careComfortline} />
            </Container>
        )
    }
    else if (carImage === 9) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={careHighline} />
            </Container>
        )
    }
    else if (carImage === 10) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={amarokHighline} />
            </Container>
        )
    }
    else if (carImage === 11) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={amarokCanyon} />
            </Container>
        )
    }
    else if (carImage === 12) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={amarokAventura} />
            </Container>
        )
    }
    else if (carImage === 13) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={crafterServis} />
            </Container>
        )
    }
    else if (carImage === 14) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={crafterOkul} />
            </Container>
        )
    }
    else if (carImage === 15) {
        return (
            <Container stretchContent={true} padding={imageContainerPadding} >
                <Image src={crafterPanelVan} />
            </Container>
        )
    }

}

const initAccordions = (carName, props) => {
    if (carName === 'Caddy Trendline') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Caddy 2.0 TDI 102 PS Trendline'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Caddy 2.0 TDI 102 PS Trendline DSG'} />
            </Container>
        )
    }
    else if (carName === 'Caddy Comfortline') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Caddy 2.0 TDI 102 PS Comfortline'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Caddy 2.0 TDI 102 PS Comfortline DSG'} />
            </Container>
        )
    }
    else if (carName === 'Caddy Exclusive') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Caddy 2.0 TDI 102 PS Exclusive'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Caddy 2.0 TDI 102 PS Exclusive DSG'} />
            </Container>
        )
    }
    else if (carName === 'Caddy Maxi Van') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Caddy Maxi Van 2.0 TDI 102 PS'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Caddy Maxi Van 2.0 TDI 102 PS DSG'} />
            </Container>
        )
    }
    else if (carName === 'Transporter Kombi') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Standart Şasi 150PS'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Uzun Şasi 150PS'} />
            </Container>
        )
    }
    else if (carName === 'Transporter Panel Van') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Transporter Panel Van 2.0 TDI (2+1) Standart Şasi 110PS'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 110PS'} />
                <PriceListOptionalAccrodion data={props.modelThree} accordHead={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 150PS    '} />

            </Container>
        )
    }
    else if (carName === 'Transporter Pikap') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Transporter Pikap 2.0 TDI (2+1) Uzun Şasi Tek Kabin 110PS'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Transporter Pikap 2.0 TDI (5+1) Uzun Şasi Çift Kabin 110PS'} />

            </Container>
        )
    }
    else if (carName === 'Caravelle Comfortline') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS DSG'} />
            </Container>
        )
    }
    else if (carName === 'Yeni Caravelle Highline') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Yeni Caravelle Highline 2.0 TDI Uzun Şasi 199PS DSG'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Yeni Caravelle Highline 2.0 TDI Uzun Şasi 199PS DSG 4Motion'} />
            </Container>
        )
    }
    else if (carName === 'Amarok Highline') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Amarok Highline 3.0 V6 TDI 204 PS Otomatik'} />
            </Container>
        )
    }
    else if (carName === 'Amarok Canyon') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Amarok Canyon 3.0 V6 TDI 204 PS Otomatik'} />
            </Container>
        )
    }
    else if (carName === 'Amarok Aventura') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Amarok Aventura 3.0 V6 TDI 258 PS Otomatik'} />
            </Container>
        )
    }
    else if (carName === 'Crafter Servis') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.modelThree} accordHead={'Crafter Servis 2.0 TDI (15+1) LWB HR 140 PS Comfortline'}/>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Crafter Servis 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Crafter Servis 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'} />
            </Container>
        )
    }
    else if (carName === 'Crafter Okul') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.modelThree} accordHead={'Crafter Okul 2.0 TDI (16+1) LWB HR 140 PS Comfortline'}/>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Crafter Okul 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Crafter Okul 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'} />
            </Container>
        )
    }
    else if (carName === 'Crafter Panel Van') {
        return (
            <Container wrap={ContainerWrap.always} stretchContent={true}>
                <PriceListOptionalAccrodion data={props.model} accordHead={'Crafter Panel Van 2.0 TDI (2+1) MWB HR 140 PS 3,5 T Comfortline'} />
                <PriceListOptionalAccrodion data={props.modelTwo} accordHead={'Crafter Panel Van 2.0 TDI (2+1) LWB HR 140 PS 3,5 T Comfortline'} />
            </Container>
        )
    }


}


/**
 * TODO @TugkanPilka: Fiyat rengini ayarla.
 */

const accordionHeadline = (carName, price) => (
    <Container
        horizontalAlignment={ContainerHorizontalAlignment.spaceBetween}
        verticalAlign={ContainerVerticalAlignment.center}
        stretchContent={true}
    >
        <Text appearance={TextAppearance.copy0200} bold>{carName}</Text>
        <Container stretchContent={true} wrap={ContainerWrap.always}>
            <Text appearance={TextAppearance.copy0200} textAlign={TextAlignment.right}>
                Liste fiyatı
            </Text>
            <Text appearance={TextAppearance.copy0250} textAlign={TextAlignment.right} bold>
                <Link>{price + ' TL'} </Link>
            </Text>
        </Container>
    </Container>
)

const topContainerPadding = {
    left: ContainerPadding.grid002,
    right: ContainerPadding.grid002
}

const accordionContainerPadding = {
    left: ContainerPadding.dynamic0140,
    right: ContainerPadding.dynamic0100,
}

const imageContainerPadding = {
    left: ContainerPadding.dynamic0100,
}

const layoutConfigurations = {
    [Breakpoints.default]: [
        { name: 'a', columns: 5 },
        { name: 'b', columns: 19 },
    ]
}



export default PriceTable;